"use strict";

function TooltipDirective($animate) {
  return {
    restrict: 'A',
    scope: {
      langKey: '@tooltip'
    },
    link: function(scope, elem) {
      var el = angular.element('<div>');

      el.addClass('tooltip__wrap');

      scope.$watch('langKey', function(value) {
        el.text(value);
        if (value.indexOf(' ') === -1) {
          el.addClass('tooltip__single');
        }
      });

      elem.on('mouseenter', function() {
        $animate.enter(el, elem);
      });

      elem.on('mouseleave', function() {
        el.remove();
      });
    }
  };
}

angular.module('dokiv')
  .directive('tooltip', ['$animate', TooltipDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/TooltipDirective.js
// module id = 253
// module chunks = 0